import React from 'react';
import "./SearchBar.css";

function SearchBar({search, setSearch}) {
	return (
		<div className="search-wrapper">
			<input
				type="text"
				placeholder="Search for a station…"
				value={search}
				onChange={(e) => setSearch(e.target.value)}
				className="search-input"
			/>
			<span
				className="search-icon material-symbols-outlined"
				aria-hidden="true"
			>
                  search
                </span>
		</div>
	);
}

export default SearchBar;